export default "__VITE_ASSET__rSPf6TkQ__"